/**
 * getResult.js
 * Written by: Alex Kasemir
 */
import quizActions from 'store/quiz/actions';
import resultActions from 'store/result/actions';
import request from '../../../request/actions';


export const GET_RESULT_START = `GET_RESULT_START`;
export const GET_RESULT_SUCCESS = `GET_RESULT_SUCCESS`;
export const GET_RESULT_FAILURE = `GET_RESULT_FAILURE`;

export const getResultStart = (id) => ({
  type: GET_RESULT_START,
  id,
});

export const getResultSuccess = (id, result) => ({
  type: GET_RESULT_SUCCESS,
  id,
  result,
});

export const getResultFailure = (id, error) => ({
  type: GET_RESULT_FAILURE,
  id,
  error,
});

/**
 * Description of the getResult action
 */

export const getResult = (id) => {
  return async (dispatch, getState) => {
    dispatch(getResultStart(id));
    const authHeader = getState().user.JWT ? `JWT ${getState().user.JWT}` : ``;
    try {
      const response = await dispatch(request(`/questions/${id}/results/`, `GET`));
      if (!response.data.played_answer && authHeader) {
        await dispatch(getResultFailure(id));
        return response.data;
      }
      if (!authHeader) {
        await dispatch(resultActions.getPlayedAnswer(id, null));
      }

      if (getState().quiz.selected !== response.data.quiz) {
        if (!getState().quiz.selected) {
          await dispatch(quizActions.getQuiz(response.data.quiz, true));
          await dispatch(quizActions.getQuizResults(response.data.quiz));
        }

        await dispatch(quizActions.selectQuiz(response.data.quiz));
      }
      await dispatch(getResultSuccess(response.data.question_id, response.data));
      return response.data;
    } catch (error) {
      dispatch(getResultFailure(id, error));
      return null;
    }
  };
};
